import { Menu, MenuProps } from "antd";
import { useState } from "react";
import { RoutingZones } from "./RoutingZones";
import { Municipalities } from "./Municipalities";
import { Neighborhoods } from "./Neighborhoods";

type MenuItem = Required<MenuProps>["items"][number];

const items: MenuItem[] = [
  {
    label: "Zonas",
    key: "routing-zones",
  },
  {
    label: "Municípios",
    key: "municipalities",
  },
  {
    label: "Bairros",
    key: "neighborhoods",
  },
];

export const Regions = () => {
  const [current, setCurrent] = useState("routing-zones");

  return (
    <div>
      <Menu
        mode="horizontal"
        onClick={(event) => setCurrent(event.key)}
        selectedKeys={[current]}
        items={items}
      />

      {current === "routing-zones" ? <RoutingZones /> : null}
      {current === "municipalities" ? <Municipalities /> : null}
      {current === "neighborhoods" ? <Neighborhoods /> : null}
    </div>
  );
};
